import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'Services', to: '/services' },
  { label: 'About', to: '/about' },
  { label: 'Testimonials', to: '/testimonials' },
  { label: 'Contact', to: '/contact' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
      style={{
        backgroundColor: scrolled ? 'rgba(10,15,28,0.97)' : '#0A0F1C',
        borderBottom: scrolled ? '1px solid rgba(204,0,0,0.3)' : '1px solid rgba(255,255,255,0.08)',
        boxShadow: scrolled ? '0 2px 20px rgba(0,0,0,0.5)' : 'none',
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src="/logo.jpg"
              alt="Auto Doctor Ltd"
              style={{ height: '50px', width: 'auto', maxWidth: '180px', objectFit: 'contain' }}
            />
          </Link>

          {/* Desktop links */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const active = location.pathname === link.to;
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className="px-4 py-2 text-sm font-medium tracking-wide transition-colors duration-200 rounded"
                  style={{
                    color: active ? '#CC0000' : '#E5E7EB',
                    borderBottom: active ? '2px solid #CC0000' : '2px solid transparent',
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.color = '#CC0000'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = active ? '#CC0000' : '#E5E7EB'; }}
                >
                  {link.label}
                </Link>
              );
            })}
            <Link
              to="/contact"
              className="ml-3 px-5 py-2 text-sm font-semibold text-white rounded transition-all duration-200"
              style={{ backgroundColor: '#CC0000' }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#AA0000'; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#CC0000'; }}
            >
              Book Now
            </Link>
          </div>

          {/* Hamburger */}
          <button
            className="md:hidden flex flex-col justify-center items-center w-10 h-10 gap-1.5"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span
              className="block w-6 h-0.5 bg-white transition-all duration-300"
              style={{ transform: menuOpen ? 'translateY(8px) rotate(45deg)' : 'none' }}
            />
            <span
              className="block w-6 h-0.5 bg-white transition-all duration-300"
              style={{ opacity: menuOpen ? 0 : 1 }}
            />
            <span
              className="block w-6 h-0.5 bg-white transition-all duration-300"
              style={{ transform: menuOpen ? 'translateY(-8px) rotate(-45deg)' : 'none' }}
            />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className="md:hidden overflow-hidden transition-all duration-300"
        style={{
          maxHeight: menuOpen ? '400px' : '0',
          backgroundColor: '#0D1220',
          borderTop: menuOpen ? '1px solid rgba(204,0,0,0.2)' : 'none',
        }}
      >
        <div className="px-4 py-4 flex flex-col gap-1">
          {navLinks.map((link) => {
            const active = location.pathname === link.to;
            return (
              <Link
                key={link.to}
                to={link.to}
                className="px-4 py-3 text-sm font-medium rounded transition-colors duration-200"
                style={{
                  color: active ? '#CC0000' : '#E5E7EB',
                  backgroundColor: active ? 'rgba(204,0,0,0.1)' : 'transparent',
                }}
              >
                {link.label}
              </Link>
            );
          })}
          <Link
            to="/contact"
            className="mt-2 px-4 py-3 text-sm font-semibold text-white text-center rounded"
            style={{ backgroundColor: '#CC0000' }}
          >
            Book Now
          </Link>
        </div>
      </div>
    </nav>
  );
}
